import router from "./index"
import store from "../store/index"

router.beforeEach((to, from, next) => {
  next()
  return
  let token = localStorage.getItem('token')
  if (token) {
    console.log('路由，我有登录')
    // store.commit('clearAxiosArr')
    return next()
  } else {
    console.log('路由，我没登录', to.path)
    if (to.path == '/login') {
      to.path == '/login' ? next() : next('/login');
    } else {
      next('/login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/permission.js